import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const CustomCarousel = ({ children, visibleItems }) => {
	const responsive = {
		superLargeDesktop: {
			breakpoint: { max: 4000, min: 3000 },
			items: 5,
		},
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: visibleItems,
			partialVisibilityGutter: 30,
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 2,
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
		},
	};
	return (
		<div className='custom-carousel'>
			<div className='side-block'></div>
			<div className='carousel-wrapper'>
				<Carousel
					responsive={responsive}
					itemClass='custom-carousel-item'
					containerClass='custom-carousel-container'
					customLeftArrow={<div className='custom-left-arrow'></div>}
					customRightArrow={<div className='custom-right-arrow'></div>}
					renderButtonGroupOutside
				>
					{children}
				</Carousel>
			</div>
			<div className='side-block'></div>
		</div>
	);
};
export default CustomCarousel;
